import { createContext } from 'react';
import { DEFAULT_THEME_NAME } from '../constants.js';

const ChartContext = /*#__PURE__*/createContext({
  id: null,
  characterWidths: {},
  characterWidthOffsets: {
    fontSize: {},
    fontWeight: {}
  },
  shouldAnimate: true,
  theme: DEFAULT_THEME_NAME,
  isPerformanceImpacted: false
});

export { ChartContext };
